import { http } from "@/api/http";

const path = "/system/login";

export interface SystemLoginRequestBody {
  userName: string;
  password: string;
  image_id: string;
  check_num: string;
}

export interface SystemLoginResult {
  token: string;
  userName: string;
  avatar: string;
  email: string;
  mobile: string;
  role: string;
  user_id: string;
  message?: string;
  gender?: number;
}

export interface SystemLoginHttpResponse {
  data: string;
  userInfo: SystemLoginUserInfo[];
  message?: string;
  error?: boolean;
}

export interface SystemLoginUserInfo {
  user_id: string;
  user_name?: string;
  avatar?: string;
  email?: string;
  mobile?: string;
  sys_permissions?: string;
  gender?: number;
}

export async function postSystemLogin(
  body: SystemLoginRequestBody,
): Promise<SystemLoginResult> {
  const response = await http.post<SystemLoginHttpResponse>(path, body);
  const user = response.userInfo?.[0];
  const serverMessage =
    typeof response.message === "string" && response.message.trim()
      ? response.message.trim()
      : undefined;
  return {
    token: response.data,
    userName: user?.user_name ?? "",
    avatar: user?.avatar ?? "",
    email: user?.email ?? "",
    mobile: user?.mobile ?? "",
    role: user?.sys_permissions ?? "",
    user_id: user?.user_id ?? "",
    message: serverMessage,
    gender: user?.gender ?? 0,
  };
}